(function($){
  
  // If product personalization is optional for this product, turn off the personalization line item property field if "Add Personalization" is set to "No"
  // Show/Hide and Enable/Disable personalization line item property field when the "Add Personalization" select field is changed/updated
  $(document).on("change","select[data-name='Add Personalization:']",function(){
	  var label= $(this).parents(".selector-wrapper").find("label").text().trim();
      	if(label== "Add Personalization:"){
		   var val=$(this).val();
			if (val.toLowerCase().indexOf("yes") >= 0) {
			   $(".line-item-property__field").show();
               $(".line-item-property__field input").prop('required',true);
			}
			else if(val.toLowerCase().indexOf("no") >= 0){
		       $(".line-item-property__field").hide();
               $(".line-item-property__field input").prop('required',false);
               $(".line-item-property__field input").removeAttr('required');
               $(".line-item-property__field input").val('');
			}
        } else {
          $(".line-item-property__field").show();
          $(".line-item-property__field input").prop('required',true);
        }
	});
	// Show/Hide and Enable/Disable personalization line item property field when the page is loaded
	$(document).ready(function(){
	   var label= $("select[data-name='Add Personalization:']").parents(".selector-wrapper").find("label").text().trim();
      	if(label== "Add Personalization:"){
            var val=$("select[data-name='Add Personalization:']").val();
            if (val.toLowerCase().indexOf("yes") >= 0) {
			   $(".line-item-property__field").show();
               $(".line-item-property__field input").prop('required',true);
			}
			else if(val.toLowerCase().indexOf("no") >= 0){
		       $(".line-item-property__field").hide();
               $(".line-item-property__field input").prop('required',false);
               $(".line-item-property__field input").removeAttr('required');
               $(".line-item-property__field input").val('');
			}
        } else {
          $(".line-item-property__field").show();
          $(".line-item-property__field input").prop('required',true);
        }
	});
  
})(jQuery);